import { getAuthenticatedHeaders } from './fetchHeaders';

export const logDocumentOpen = (partNumber, userLanguage, section, hasActivationKey) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/logDocumentOpen?partNumber=${partNumber}&userLanguage=${userLanguage}`;
        if (!!section) {
            uri += `&section=${section}`;
        }
        if (hasActivationKey) {
            uri += '&fromG3=true';
        }
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logDocumentDownload = (partNumber, userLanguage, section) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/logDocumentDownload?partNumber=${partNumber}&userLanguage=${userLanguage}`;
        if (!!section) {
            uri += `&section=${encodeURIComponent(section)}`;
        }
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logDownloadFailed = (partNumber) => {
    return getAuthenticatedHeaders().then((headers) => {
        const uri = `/insights/logDownloadFailed?partNumber=${partNumber}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logFilterUsed = (filterType, filterValue) => {
    if (!filterValue) {
        return;
    }

    return getAuthenticatedHeaders().then((headers) => {
        return fetch(`/insights/logFilterUsed?filterType=${filterType}&filterValue=${filterValue}`, { headers, method: 'post' })
    });
}

export const logDisplayDevice = (os, mobile, browser, deviceType) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/logDisplayDevice/${deviceType}?browser=${browser}&os=${os}`;
        if (!!mobile) {
            uri += `&mobile=${mobile}`;
        }
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logFeatureUsage = (feature) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogFeatureUsed?feature=${feature}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logCalculatorUsage = (model) => {
    return getAuthenticatedHeaders({ 'Content-Type': 'application/json' }).then((headers) => {
        let uri = `/insights/LogCalculator`;
        return fetch(uri, { headers, method: 'post', body: JSON.stringify(model) })
    });
}

export const logCalculatorTimeOnPageUsage = (model) => {
    return getAuthenticatedHeaders({ 'Content-Type': 'application/json' }).then((headers) => {
        let uri = `/insights/LogCalculatorTimeOnPage`;
        return fetch(uri, { headers, method: 'post', body: JSON.stringify(model) })
    });
}

export const logCalculatorDownloadUsage = (model) => {
    return getAuthenticatedHeaders({ 'Content-Type': 'application/json' }).then((headers) => {
        let uri = `/insights/LogCalculatorDownload`;
        return fetch(uri, { headers, method: 'post', body: JSON.stringify(model) })
    });
}

export const logCalculatorEventUsage = (model) => {
    return getAuthenticatedHeaders({ 'Content-Type': 'application/json' }).then((headers) => {
        let uri = `/insights/LogCalculatorEvent`;
        return fetch(uri, { headers, method: 'post', body: JSON.stringify(model) })
    });
}

export const logRequestTiming = (url, requestTime) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogRequestTiming?url=${encodeURIComponent(url)}&requestTime=${requestTime}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logFailedRequestTiming = (url, requestTime) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogFailedRequestTiming?url=${encodeURIComponent(url)}&requestTime=${requestTime}`;
        return fetch(uri, { headers, method: 'post' })
    });
}


export const logListView = (mode, type, query, selectedFamilies, selectedGroups, year) => {
    return getAuthenticatedHeaders({ 'Content-Type': 'application/json' }).then((headers) => {
        return fetch(
            `/insights/logListView`,
            {
                headers,
                method: 'post',
                body: JSON.stringify({
                    listMode: mode,
                    documentType: `${type}`,
                    isSearch: !!query,
                    query,
                    isFamilyFiltered: !!selectedFamilies,
                    selectedFamilies,
                    isGroupFiltered: !!selectedGroups,
                    selectedGroups,
                    year: year
                })
            })
    });
}

export const logEngineSerialSearch = (serialNumber, modelNumber) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogEngineSerialSearch?serialNumber=${serialNumber}&modelNumber=${modelNumber}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logEngineModelSearch = (modelNumber) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogEngineModelSearch?modelNumber=${modelNumber}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logVesselInfoView = (serialNumber) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogVesselInfoView?serialNumber=${serialNumber}`;
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logFaultListView = (query, familyNameId) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogFaultListView?query=${query}`;
        if (!!familyNameId) {
            uri += `&familyNameId=${familyNameId}`;
        }
        return fetch(uri, { headers, method: 'post' })
    });
}

export const logFaultView = (faultIdentifier, familyNameId, isUfc) => {
    return getAuthenticatedHeaders().then((headers) => {
        let uri = `/insights/LogFaultView?faultIdentifier=${encodeURIComponent(faultIdentifier)}&familyNameId=${familyNameId}&isUfc=${isUfc}`;
        return fetch(uri, { headers, method: 'post' })
    });
}